module.exports = __webpack_public_path__ + "static/media/ard-na-murkan.6f355ad9.svg";